export function getImageKey(image: File): string {
  return image.name + image.size;
}

export const isImageValid = (file: File): Promise<boolean> => {
  if (file.size === 0) {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    const img = new window.Image();
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      resolve(true);
    };
    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      resolve(false);
    };
    img.src = URL.createObjectURL(file);
  });
};
